let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9s4Da")).then(() => parcelRequire('8LZxx'));